export enum errorCodeRefund {
  LOA0004 = 'LOA0004',
  GEN0003 = 'GEN0003',
  GEN0001 = 'GEN0001',
  LOA0005 = 'LOA0005',
  LOA0011 = 'LOA0011',
  LOA0014 = 'LOA0014',
  LOA0032 = 'LOA0032',
  LOA0033 = 'LOA0033',
}

export enum messageCode {
  messageLOA0004 = 'El valor es mayor que ',
  messageGEN0003 = 'El valor tiene que ser mayor que 0',
  messageGEN0001 = 'El campo no puede estar vacío',
  messageLOA0005 = 'El valor introducido es superior al máximo permitido de ',
  messageLOA0011 = 'No es posible procesar la devolución en el mismo día. Para cualquier duda ponte en contacto con nosotros.',
  messageLOA0032 = 'No es posible realizar la devolución vía compensación. Envíanos el documento de anulación firmado junto con el comprobante de transferencia a incidenciacliente@peppergroup.es para continuar el proceso.',
  messageLOA0033 = 'No es posible realizar una devolución total el mismo día que una devolución parcial.',
}

export const {
  messageLOA0004,
  messageGEN0003,
  messageGEN0001,
  messageLOA0005,
  messageLOA0011,
  messageLOA0032,
  messageLOA0033,
} = messageCode;

export interface RefundSimulation {
  amount: number;
  balance: number;
  customer_expenses: number;
  discount: number;
  loan_id: string;
}
